/**
 * Banesco General Header JavaScript
 *
 * For template-general.php (Banesco site) only.
 * Handles:
 * - Mobile menu open/close
 * - Mobile submenu accordion (regular + mega-menu)
 * - Two-tier sub-item toggles
 * - Language/location picker dropdowns
 * - Search toggle + live search
 * - Desktop mega-menu fetch + toggle
 * - Primary picker / outlined button dropdowns
 */

(function () {
    'use strict';

    // Only run on general header pages
    if (!document.getElementById('masthead')) return;

    // =========================================================================
    // Mobile Menu Open/Close
    // =========================================================================

    var openBtn = document.getElementById('masthead_mobile_open');
    var closeBtn = document.getElementById('masthead_mobile_close');

    if (openBtn) {
        openBtn.addEventListener('click', function (e) {
            e.preventDefault();
            document.body.classList.add('show-masthead-mobile');
        });
    }

    if (closeBtn) {
        closeBtn.addEventListener('click', function (e) {
            e.preventDefault();
            document.body.classList.remove('show-masthead-mobile');
        });
    }

    // =========================================================================
    // Mobile Submenu Accordion
    // =========================================================================

    // Top-level items with children
    document.querySelectorAll('#masthead_mobile .menu-item-has-children > a').forEach(function (link) {
        link.addEventListener('click', function (e) {
            var parent = link.parentElement;
            var submenu = parent.querySelector('.sub-menu');
            var megaMenu = parent.querySelector('.general-header__dropdown-wrapper');
            if (submenu || megaMenu) {
                e.preventDefault();
                // Close other open items at same level
                var siblings = parent.parentElement ? parent.parentElement.children : [];
                for (var i = 0; i < siblings.length; i++) {
                    if (siblings[i] !== parent) {
                        siblings[i].classList.remove('submenu-active');
                    }
                }
                parent.classList.toggle('submenu-active');
            }
        });
    });

    // Two-tier sub-items: dropdown-subitem links inside .sub-menu
    // Use event delegation because mega-menu content is injected async via AJAX
    var mobileNav = document.getElementById('masthead_mobile');
    if (mobileNav) {
        mobileNav.addEventListener('click', function (e) {
            var link = e.target.closest('.desktop-child-visible .sub-menu > li.dropdown-subitem > a');
            if (!link) return;
            e.preventDefault();
            e.stopPropagation();
            var parent = link.parentElement;
            // Close sibling sub-items
            var siblings = parent.parentElement ? parent.parentElement.children : [];
            for (var i = 0; i < siblings.length; i++) {
                if (siblings[i] !== parent) {
                    siblings[i].classList.remove('submenu-active');
                }
            }
            parent.classList.toggle('submenu-active');
        });
    }

    // =========================================================================
    // Language / Location Picker Dropdowns
    // =========================================================================

    document.querySelectorAll('.newlanguage-picker__inner').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
            e.preventDefault();
            document.querySelectorAll('.new_pickers__item--location.active').forEach(function (p) {
                p.classList.remove('active');
            });
            var picker = btn.closest('.new_pickers__item--language');
            if (picker) picker.classList.toggle('active');
        });
    });

    // Locations is now a plain link to /banking-centers/ (no dropdown), so no
    // toggle handler is bound for it. The language picker keeps its dropdown.

    // Enroll-in-Online-Banking dropdown — the trigger is a link; prevent
    // navigation on click and toggle the dropdown open/closed instead.
    document.querySelectorAll('.uheader__enroll-dropdown > .uheader__utility-link').forEach(function (link) {
        link.addEventListener('click', function (e) {
            e.preventDefault();
            var wrapper = link.closest('.uheader__enroll-dropdown');
            if (wrapper) wrapper.classList.toggle('active');
        });
    });

    // Close pickers on outside click
    document.addEventListener('click', function (e) {
        if (!e.target.closest('.new_pickers__item--language')) {
            document.querySelectorAll('.new_pickers__item--language.active').forEach(function (p) {
                p.classList.remove('active');
            });
        }
        if (!e.target.closest('.new_pickers__item--location')) {
            document.querySelectorAll('.new_pickers__item--location.active').forEach(function (p) {
                p.classList.remove('active');
            });
        }
        if (!e.target.closest('.uheader__enroll-dropdown')) {
            document.querySelectorAll('.uheader__enroll-dropdown.active').forEach(function (w) {
                w.classList.remove('active');
            });
        }
    });

    // =========================================================================
    // Search Toggle
    // =========================================================================

    document.querySelectorAll('.search-input').forEach(function (searchInput) {
        var openBtn = searchInput.querySelector('.search-input__open');
        var closeBtn = searchInput.querySelector('.search-input__button');

        if (openBtn) {
            openBtn.addEventListener('click', function (e) {
                e.preventDefault();
                searchInput.classList.add('active');
                var input = searchInput.querySelector('.search-input__entry');
                if (input) input.focus();
            });
        }

        if (closeBtn) {
            closeBtn.addEventListener('click', function (e) {
                e.preventDefault();
                searchInput.classList.remove('active');
            });
        }
    });

    document.addEventListener('click', function (e) {
        if (!e.target.closest('.search-input')) {
            document.querySelectorAll('.search-input.active').forEach(function (s) {
                s.classList.remove('active');
            });
        }
    });

    // =========================================================================
    // Mobile Mega-Menu Accordion (section headers)
    // =========================================================================

    function initMobileMegaMenuAccordions() {
        document.querySelectorAll('#masthead_mobile .general-header__column-links ul > li > a').forEach(function (anchor) {
            if (!anchor.querySelector('strong')) return;

            var ul = anchor.closest('ul');
            if (!ul || ul.dataset.megaInit) return;
            if (ul.querySelectorAll('a').length <= 1) return;

            ul.classList.add('mobile-mega-section');
            ul.dataset.megaInit = 'true';
            var li = anchor.closest('li');
            li.classList.add('mobile-mega-section-header');

            li.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();

                var wrapper = li.closest('.general-header__dropdown-wrapper');
                if (wrapper) {
                    wrapper.querySelectorAll('.mobile-mega-section.section-active').forEach(function (otherUl) {
                        if (otherUl !== ul) otherUl.classList.remove('section-active');
                    });
                }

                ul.classList.toggle('section-active');
            });
        });

        // Stop propagation on mega-menu content
        document.querySelectorAll('#masthead_mobile .general-header__column-links').forEach(function (menu) {
            if (menu.dataset.stopBound) return;
            menu.dataset.stopBound = 'true';
            menu.addEventListener('click', function (e) {
                e.stopPropagation();
            });
        });
    }

    // =========================================================================
    // Desktop + Mobile Mega-Menu (preloaded server-side via PHP walker)
    // =========================================================================

    var desktopDropdowns = document.querySelectorAll(
        '.lheader .menu-primary .menu-item.desktop-dropdown, ' +
        '#masthead_mobile .menu-primary-mobile .menu-item.desktop-dropdown'
    );

    // Mega-menu HTML is now preloaded in the DOM by Pacific_Megamenu_Walker.
    // Init mobile accordions immediately since content is already there.
    initMobileMegaMenuAccordions();

    // Fallback: if any dropdown is missing its content (e.g. cache issue),
    // fetch it via REST API as before.
    desktopDropdowns.forEach(function (menuItem) {
        if (menuItem.querySelector('.general-header__dropdown-wrapper')) return;

        var childrenClass = Array.from(menuItem.classList).find(function (cls) {
            return cls.startsWith('childrens-');
        });

        var parentItem = null;
        if (childrenClass) {
            parentItem = childrenClass.slice(10);
        } else if (menuItem.classList.contains('desktop-child-visible')) {
            var linkText = menuItem.querySelector('a')?.textContent?.trim()?.toLowerCase();
            if (linkText === 'international' || linkText === 'internacional') {
                parentItem = 'international';
            }
        }

        if (parentItem) {
            var langPrefix = window.location.pathname.match(/^\/(es|pt)\//);
            var basePath = langPrefix ? '/' + langPrefix[1] : '';

            fetch(window.location.origin + basePath + '/wp-json/general-menu/v1/options/?parent_item=' + parentItem)
                .then(function (response) { return response.json(); })
                .then(function (data) {
                    if (data && data.data && data.data.html) {
                        menuItem.insertAdjacentHTML('beforeend', data.data.html);
                        if (menuItem.closest('#masthead_mobile')) {
                            initMobileMegaMenuAccordions();
                        }
                    }
                })
                .catch(function (err) {
                    console.error('Failed to fetch mega-menu content:', err);
                });
        }
    });

    // =========================================================================
    // Desktop Dropdown Toggle (click-based)
    // =========================================================================

    // Prevent navigation on ALL dropdown top-level <a> links (desktop + mobile)
    desktopDropdowns.forEach(function (menuItem) {
        var topLink = menuItem.querySelector(':scope > a');
        if (topLink) {
            topLink.addEventListener('click', function (e) {
                e.preventDefault();
            });
        }
        // Also prevent on sub-menu tab links (two-tier items)
        if (menuItem.classList.contains('desktop-child-visible')) {
            menuItem.querySelectorAll(':scope > .sub-menu > li > a').forEach(function (a) {
                a.addEventListener('click', function (e) {
                    e.preventDefault();
                });
            });
        }
    });

    desktopDropdowns.forEach(function (menuItem) {
        // Desktop-only toggle logic (mobile uses its own accordion handler above)
        if (menuItem.closest('#masthead_mobile')) return;

        // Two-tier sub-tabs (.dropdown-subitem) are themselves .desktop-dropdown, so
        // they'd otherwise get their OWN competing toggle handler that hijacks the
        // click and toggles the sub-tab as if it were a top-level menu (the "fidgety"
        // double-toggle). Skip them here — the parent item's two-tier branch below
        // (isChildVisible && clickedSubMenuItem) is what manages sub-tab switching.
        if (menuItem.classList.contains('dropdown-subitem')) return;

        menuItem.addEventListener('click', function (e) {
            if (e.target.closest('.general-header__dropdown-wrapper a')) return;

            var isChildVisible = menuItem.classList.contains('desktop-child-visible');
            var clickedSubMenuItem = e.target.closest('.sub-menu > li');

            if (isChildVisible && clickedSubMenuItem) {
                e.preventDefault();
                e.stopPropagation();

                var wasActive = clickedSubMenuItem.classList.contains('submenu-active');
                menuItem.querySelectorAll('.sub-menu > li').forEach(function (li) {
                    li.classList.remove('submenu-active');
                });
                if (!wasActive) clickedSubMenuItem.classList.add('submenu-active');
                return;
            }

            if (e.target.closest('.sub-menu a') && !isChildVisible) return;

            e.preventDefault();
            e.stopPropagation();

            var isActive = menuItem.classList.contains('submenu-active');

            desktopDropdowns.forEach(function (item) {
                item.classList.remove('submenu-active');
                item.querySelectorAll('.sub-menu > li').forEach(function (li) {
                    li.classList.remove('submenu-active');
                });
            });

            if (!isActive) {
                menuItem.classList.add('submenu-active');
                document.body.classList.add('newmenu-shown');
            } else {
                document.body.classList.remove('newmenu-shown');
            }
        });
    });

    // Close desktop dropdown on outside click
    document.addEventListener('click', function (e) {
        if (!e.target.closest('.menu-item.desktop-dropdown')) {
            desktopDropdowns.forEach(function (item) {
                if (item.closest('#masthead_mobile')) return;
                item.classList.remove('submenu-active');
            });
            document.body.classList.remove('newmenu-shown');
        }
    });

    // =========================================================================
    // Same-page links close the menus (replaces the mobile-only legacy C3 port)
    // =========================================================================

    // Mega-menu items such as Personal › Savings point at an anchor on their own
    // page (/personal/deposits/us/#money). On that page the click only scrolls,
    // so the desktop mega-menu / mobile menu stayed open over the content.
    // Capture phase: the mobile mega-menu content stops click propagation
    // (.general-header__column-links), so a bubbling listener never sees those
    // clicks. The close runs after dispatch and only if nothing prevented the
    // default, so dropdown toggles, two-tier tabs and mobile section headers
    // (all preventDefault) keep their own behavior.

    function isSamePageLink(link) {
        var href = link.getAttribute('href') || '';
        if (!href || href === '#') return false;
        var url;
        try {
            url = new URL(href, window.location.href);
        } catch (err) {
            return false;
        }
        var trimSlash = function (path) { return path.replace(/\/+$/, ''); };
        return url.origin === window.location.origin &&
            trimSlash(url.pathname) === trimSlash(window.location.pathname) &&
            url.search === window.location.search;
    }

    function closeMenus() {
        desktopDropdowns.forEach(function (item) {
            if (item.closest('#masthead_mobile')) return;
            item.classList.remove('submenu-active');
            item.querySelectorAll('.sub-menu > li').forEach(function (li) {
                li.classList.remove('submenu-active');
            });
        });
        document.body.classList.remove('newmenu-shown');
        document.body.classList.remove('show-masthead-mobile');
        var mainEl = document.querySelector('#main');
        if (mainEl) mainEl.classList.remove('element-blured');
    }

    document.addEventListener('click', function (e) {
        var link = e.target.closest('#masthead a[href], #masthead_mobile a[href]');
        if (!link || !isSamePageLink(link)) return;
        setTimeout(function () {
            if (!e.defaultPrevented) closeMenus();
        }, 0);
    }, true);

    // =========================================================================
    // Live Search
    // =========================================================================

    var searchDebounceTimer = null;

    function clearSearch(searchInput) {
        searchInput.classList.remove('active');
        var entry = searchInput.querySelector('.search-input__entry');
        var results = searchInput.querySelector('#searchResults, #blockSearchResults');
        if (entry) entry.value = '';
        if (results) results.textContent = '';
    }

    function buildHighlightedText(text, term) {
        var frag = document.createDocumentFragment();
        if (!term) {
            frag.appendChild(document.createTextNode(text));
            return frag;
        }
        var escaped = term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        var regex = new RegExp('(' + escaped + ')', 'gi');
        var parts = text.split(regex);
        parts.forEach(function (part) {
            if (regex.test(part)) {
                var span = document.createElement('span');
                span.className = 'highlight';
                span.textContent = part;
                frag.appendChild(span);
            } else {
                frag.appendChild(document.createTextNode(part));
            }
            regex.lastIndex = 0;
        });
        return frag;
    }

    function handleLiveSearch(searchInput) {
        var entry = searchInput.querySelector('.search-input__entry, .search-general__entry');
        var resultsContainer = searchInput.querySelector('#searchResults, #blockSearchResults');
        if (!entry || !resultsContainer) return;

        // The search-general block reveals its results panel via .results-visible on
        // its form wrapper (the header uses .search-input.active, toggled elsewhere).
        var blockWrapper = searchInput.querySelector('.search-general__form-wrapper');
        var setVisible = function (on) {
            if (blockWrapper) blockWrapper.classList.toggle('results-visible', on);
        };

        // Clear icon (search-general block) resets the field + results.
        var clearIcon = searchInput.querySelector('.search-general__clear-search-icon');
        if (clearIcon) {
            clearIcon.addEventListener('click', function () {
                entry.value = '';
                resultsContainer.textContent = '';
                setVisible(false);
            });
        }

        entry.addEventListener('input', function () {
            var term = entry.value.trim();
            clearTimeout(searchDebounceTimer);

            if (term.length < 2) {
                resultsContainer.textContent = '';
                setVisible(false);
                return;
            }

            searchDebounceTimer = setTimeout(function () {
                var origin = window.location.origin;
                var langPrefix = window.location.pathname.match(/^\/(es|pt)\//);
                var basePath = langPrefix ? '/' + langPrefix[1] : '';

                fetch(origin + basePath + '/wp-json/searchfor/v1/searchtext?search_term=' + encodeURIComponent(term))
                    .then(function (r) { return r.json(); })
                    .then(function (data) {
                        resultsContainer.textContent = '';
                        setVisible(true);

                        if (data.count === 0) {
                            var noResults = document.createElement('div');
                            noResults.className = 'search-no-results';
                            noResults.textContent = 'No results found';
                            if (data.product_page) {
                                noResults.textContent = 'No results found. ';
                                var link = document.createElement('a');
                                link.href = data.product_page;
                                link.textContent = 'Browse products';
                                noResults.appendChild(link);
                            }
                            resultsContainer.appendChild(noResults);
                            return;
                        }

                        var countEl = document.createElement('div');
                        countEl.className = 'search-result-count';
                        countEl.textContent = data.count + ' result' + (data.count !== 1 ? 's' : '') + ' found';
                        resultsContainer.appendChild(countEl);

                        var parser = new DOMParser();
                        var doc = parser.parseFromString('<div>' + data.html + '</div>', 'text/html');
                        var items = doc.querySelectorAll('.search-result-item');

                        var maxItems = Math.min(items.length, 5);
                        for (var i = 0; i < maxItems; i++) {
                            var sourceItem = items[i];
                            var resultDiv = document.createElement('div');
                            resultDiv.className = 'search-result-item';
                            var targetUrl = sourceItem.getAttribute('data-target-value') || '#';
                            resultDiv.appendChild(buildHighlightedText(sourceItem.textContent, term));
                            resultDiv.addEventListener('click', (function (url) {
                                return function () { window.location.href = url; };
                            })(targetUrl));
                            resultsContainer.appendChild(resultDiv);
                        }

                        if (data.count > 5) {
                            var viewAll = document.createElement('div');
                            viewAll.className = 'search-view-all-wrapper';
                            var viewAllLink = document.createElement('a');
                            viewAllLink.href = '/?s=' + encodeURIComponent(term);
                            viewAllLink.textContent = 'View all ' + data.count + ' results';
                            viewAll.appendChild(viewAllLink);
                            resultsContainer.appendChild(viewAll);
                        }
                    })
                    .catch(function (err) {
                        console.error('Search failed:', err);
                    });
            }, 300);
        });
    }

    document.querySelectorAll('.search-input, .search-general').forEach(function (si) {
        handleLiveSearch(si);
    });

    // =========================================================================
    // Primary Picker / Outlined Button Dropdowns
    // =========================================================================

    document.querySelectorAll('.primary-picker').forEach(function (picker) {
        var button = picker.querySelector('.primary-picker__button');
        if (button) {
            button.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                document.querySelectorAll('.outlined-button-wrapper.active').forEach(function (el) {
                    el.classList.remove('active');
                });
                picker.classList.toggle('active');
            });
        }
    });

    document.querySelectorAll('.outlined-button-wrapper').forEach(function (wrapper) {
        var button = wrapper.querySelector('.outlined-button');
        if (button) {
            button.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                document.querySelectorAll('.primary-picker.active').forEach(function (el) {
                    el.classList.remove('active');
                });
                wrapper.classList.toggle('active');
            });
        }
    });

    // Close header dropdowns on outside click
    document.addEventListener('click', function (e) {
        if (!e.target.closest('.primary-picker')) {
            document.querySelectorAll('.primary-picker.active').forEach(function (el) {
                el.classList.remove('active');
            });
        }
        if (!e.target.closest('.outlined-button-wrapper')) {
            document.querySelectorAll('.outlined-button-wrapper.active').forEach(function (el) {
                el.classList.remove('active');
            });
        }
    });

    // Close on Escape key
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
            desktopDropdowns.forEach(function (item) {
                if (item.closest('#masthead_mobile')) return;
                item.classList.remove('submenu-active');
            });
            document.body.classList.remove('newmenu-shown');
            document.querySelectorAll('.primary-picker.active, .outlined-button-wrapper.active').forEach(function (el) {
                el.classList.remove('active');
            });
            document.querySelectorAll('.search-input.active').forEach(function (s) {
                clearSearch(s);
            });
        }
    });
})();
